module.exports = __webpack_public_path__ + "a901d7a07e805dc97cae7b9759f33fc3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/bmw.svg
// module id = 6kB6
// module chunks = 0